import { render, staticRenderFns } from "./svg-icon.vue?vue&type=template&id=51846e8a&"
import script from "./svg-icon.vue?vue&type=script&lang=js&"
export * from "./svg-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johndwells/Git/hys/penge-polls/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51846e8a')) {
      api.createRecord('51846e8a', component.options)
    } else {
      api.reload('51846e8a', component.options)
    }
    module.hot.accept("./svg-icon.vue?vue&type=template&id=51846e8a&", function () {
      api.rerender('51846e8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/base/svg-icon.vue"
export default component.exports